module.exports = __webpack_public_path__ + "static/media/patient-management-software-healthcare-hero.23e8e003.webp";